import { Toast } from 'antd-mobile';
import { lasserBairamInfo, lasserBairamGiftPack, lasserBairamSceneInfo, lasserBairamRankList, lasserBairamCollect, lasserBairamHonor } from '@/services/activity';

export default {
  namespace: 'lasserBairam',
  state: {
    status: 0,
    endTime: 0,
    title: '',
    titleUrl: '',
    rules: '',
    limitedGifts: [],
    sceneRewardList: [],
    totalSendRewards: [],
    totalReceiveRewards: [],
    dailyGiftReward: {},
    redEnvelopeStatus: 0,
    redPackTitle: '',
    dailyTop1User: {},
    beforeDate: '',
    luckyUserList: [],
    luckyTimeList: [],
    sendGiftCoins: 0,
    needGiftCoins: 0,
    nextRoundCountDown: 0,
    bottomDesc: '',
    giftPackValueList: [],
    id: 1,
    startCoin: 0,
    currentCoin: 0,
    endCoin: 0,
    sceneInfoList: [],
    selfInfo: {},
    ranks: [],
    lastId: '',
    hasMore: true,
    unLockSceneList: [],
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        status: payload.status || 0,
        endTime: payload.endTime || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        limitedGifts: payload.limitedGifts || [],
        sceneRewardList: payload.sceneRewardList || [],
        totalSendRewards: payload.totalSendRewards || [],
        totalReceiveRewards: payload.totalReceiveRewards || [],
        dailyGiftReward: payload.dailyGiftReward || {},
        redEnvelopeStatus: payload.redEnvelopeStatus || 0,
        redPackTitle: payload.redPackTitle || '',
      };
    },
    updateGiftPack(state, { payload }) {
      return {
        ...state,
        dailyTop1User: payload.dailyTop1User || {},
        beforeDate: payload.beforeDate || '',
        luckyUserList: payload.luckyUserList || [],
        luckyTimeList: payload.luckyTimeList || [],
        sendGiftCoins: payload.sendGiftCoins || 0,
        needGiftCoins: payload.needGiftCoins || 0,
        nextRoundCountDown: payload.nextRoundCountDown || 0,
        bottomDesc: payload.bottomDesc || '',
        giftPackValueList: payload.giftPackValueList || [],
      };
    },
    updateSceneInfo(state, { payload }) {
      return {
        ...state,
        id: payload.id || 1,
        startCoin: payload.startCoin || 0,
        currentCoin: payload.currentCoin || 0,
        endCoin: payload.endCoin || 0,
        sceneInfoList: payload.sceneInfoList || [],
      };
    },
    updateList(state, { payload }) {
      let lastId = '';
      let list = payload.force ? [] : [...state.ranks];
      if (payload.rankInfo && payload.rankInfo.ranks && payload.rankInfo.ranks.length) {
        list = [...list, ...payload.rankInfo.ranks];
        lastId = payload.rankInfo.ranks[payload.rankInfo.ranks.length - 1].userId;
      }
      return {
        ...state,
        selfInfo: (payload.rankInfo && payload.rankInfo.selfInfo) || {},
        ranks: list || [],
        lastId: lastId,
        hasMore: payload.rankInfo && payload.rankInfo.ranks && payload.rankInfo.ranks.length < 20 ? false : true,
      };
    },
    updateHonor(state, { payload }) {
      return {
        ...state,
        unLockSceneList: payload || [],
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(lasserBairamInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return data;
    },
    *getGiftPack({ payload }, { call, put }) {
      const { error, data } = yield call(lasserBairamGiftPack, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateGiftPack',
        payload: data,
      });
      return true;
    },
    *getSceneInfo({ payload }, { call, put }) {
      const { error, data } = yield call(lasserBairamSceneInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateSceneInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateSceneInfo',
        payload: data,
      });
      return data;
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.lasserBairam);
      const { error, data } = yield call(lasserBairamRankList, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *getCollect({ payload }, { call, put }) {
      const { error, data } = yield call(lasserBairamCollect, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    *getHonor({ payload }, { call, put }) {
      const { error, data } = yield call(lasserBairamHonor, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateHonor',
        payload: data,
      });
      return data;
    },
  },
};
